var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasUser)?_c('div',{staticClass:"single-team",attrs:{"title":_vm.user.fullname},on:{"click":function($event){$event.preventDefault();return _vm.selectedOnlineUser.apply(null, arguments)}}},[_c('span',{staticClass:"team-user-img"},[_c('avatar',{attrs:{"user-uid":_vm.userUid,"size":"xs"}})],1),_c('span',{staticClass:"online"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }